<template>
  <div
    :style="{'max-height': maxHeight + 'px'}"
    class="borderx"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Borderx',
  props: {
    maxHeight: {
      type: Number,
      default: 220
    }
  }
}
</script>

<style scoped>
  .borderx {
    width: 100%;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    padding: 10px 15px;
    overflow: auto;
    margin: 5px 0px;
  }
</style>
